<template>
  <div role="group" class="user" v-click-outside="onClickOutside">
    <span class="user__subscription">
      <font-awesome-icon :icon="['fab', 'twitch']" pull="left" size="lg" />
      {{ subscription }}
    </span>

    <span class="user__name">{{ name }}</span>

    <button
      aria-collapsable="true"
      :aria-expanded="showUserMenu.toString()"
      :aria-label="`${name} User Menu`"
      @click="handleUserMenu"
      class="user__avatar"
      :class="`user__avatar--${user.subscription}`"
    >
      <img :src="user.profileImageUrl" alt />
    </button>
    <user-menu :show="showUserMenu" />
  </div>
</template>

<script>
import UserMenu from './UserMenu';

import { mapState, mapGetters } from 'vuex';
import vClickOutside from 'v-click-outside';

export default {
  name: 'header-user',
  components: { UserMenu },
  data() {
    return {
      showUserMenu: false,
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  methods: {
    handleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },
    onClickOutside() {
      this.showUserMenu = false;
    },
  },
  mounted() {
    window.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.showUserMenu) {
        this.showUserMenu = false;
      }
    });
  },
  computed: {
    ...mapState('auth', {
      user: state => state.user,
    }),
    ...mapGetters('auth', ['name', 'subscription']),
  },
};
</script>

<style lang="scss" scoped>
$prime: #00aae2;

.user {
  display: inline-flex;
  align-items: center;
  position: relative;
  margin-left: auto;

  &__subscription {
    color: color('twitch');
    font-weight: 500;
    margin-right: 2rem;
    justify-content: center;
    align-items: center;
  }

  &__name {
    font-weight: 500;
    margin-right: 0.5rem;
    display: none;
  }

  &__avatar {
    $avatar-size: 48px;
    width: $avatar-size;
    height: $avatar-size;
    padding: 0;
    border-radius: $avatar-size / 2;
    overflow: hidden;
    border: 2px solid color('grey');
    background: white;
    cursor: pointer;

    &:focus,
    &:active {
      outline: none;
      box-shadow: 0 0 4px 2px rgba(color('primary'), 1);
    }

    &:hover {
      background: black;
      img {
        opacity: 0.5;
      }
    }

    &--1000 {
      border-color: color('twitch');

      &:focus,
      &:active {
        box-shadow: 0 0 4px 2px rgba(color('twitch'), 1);
      }
    }

    &--prime {
      border-color: $prime;

      &:focus,
      &:active {
        box-shadow: 0 0 4px 2px rgba($prime, 1);
      }
    }

    img {
      border: 2px solid white;
      border-radius: $avatar-size / 2;
      max-width: 100%;
      opacity: 1;
      transition: all 128ms ease-in-out;
    }
  }
}

@media screen and (min-width: 1024px) {
  .user__subscription,
  .user__name {
    display: inline-flex;
  }
}
</style>
